// src/pages/UsersPage.js
import { Container, Card, Alert } from 'react-bootstrap';
import UserList from '../../components/users/UserList';
import useAuth from '../../hooks/useAuth';

const UsersPage = () => {
  const { loading, canManageUsers, user } = useAuth();

  if (loading) {
    return (
      <Container className="mt-4">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Загрузка...</span>
          </div>
        </div>
      </Container>
    );
  }

  if (!canManageUsers) {
    return (
      <Container className="mt-4">
        <Alert variant="danger">
          <h5>Доступ запрещён</h5>
          <p>У вас нет прав для управления пользователями.</p>
        </Alert>
      </Container>
    );
  }

  return (
    <Container className="mt-4">
      <Card>
        <Card.Header>
          <h3>Управление пользователями</h3>
          <p className="mb-0 text-muted">
            {user?.superuser ? 'Вы — superuser': 'Вы — администратор'}
          </p>
        </Card.Header>
        <Card.Body>
          <UserList />
        </Card.Body>
      </Card>
    </Container>
  );
};

export default UsersPage;




